import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { Navigation, Stock, Footer } from "./components";
import useToken from "./useToken.js";
import Login from "./components/Login/Login";
import Movements from "./components/Movements/Movements";
import Count from "./components/Count/Count";
import Shiplists from "./components/Shiplists/Shiplists";
import Form from "./components/Form/Form";
import { Col, Container, Row } from "react-bootstrap";

function App() {
  // const { token, setToken } = useToken();

  // if (token && token !== "q>)*8n[TfhTyZAW") {
  //   alert("Invalid Log-in Token");
  //   localStorage.removeItem("token");
  // }

  // if (!token) {
  //   return <Login setToken={setToken} />;
  // }

  const [success, setSuccess] = React.useState(false);

  return (
    <div className="App">
      <Router>
        <Container>
          <Row className="my-4 justify-content-center">
            <Col md={10} xl={8}>
              <Form success={success} setSuccess={setSuccess} />
            </Col>
          </Row>
          {/*<Navigation />
        <Switch>
        <Route path="/" exact component={() => <Stock />} />
        <Route path="/stock" exact component={() => <Stock />} />
        <Route path="/movements" exact component={() => <Movements />} />
        <Route path="/count" exact component={() => <Count />} />
        <Route path="/shiplists" exact component={() => <Shiplists />} />
      </Switch>*/}
        </Container>
        <div hidden={success}>
          <Footer />
        </div>
      </Router>
    </div>
  );
}
export default App;
